export enum AttachmentSelectorFeature {
  CdnEmbed,
  PlacementOptions,
  Responsive,
  DragAndDrop,
  CopyMode
}

export const ATTACHMENT_SELECTOR_FEATURES_TOKEN = 'ATTACHMENT_SELECTOR_FEATURES';

export interface IAttachmentSelectorFeaturesService {
  hasFeature: (feature: AttachmentSelectorFeature) => boolean;
}
